import { Node, mergeAttributes } from "@tiptap/core";

export const HieraVideo = Node.create({
  name: "hieraVideo",
  group: "block",
  atom: true,
  addAttributes() {
    return {
      src: { default: null },
    };
  },
  parseHTML() {
    return [{ tag: 'video[data-hiera="video"]' }];
  },
  renderHTML({ HTMLAttributes }) {
    return [
      "video",
      mergeAttributes(HTMLAttributes, {
        "data-hiera": "video",
        controls: "true",
        playsinline: "true",
        preload: "metadata",
      }),
    ];
  },
});

export const HieraGif = Node.create({
  name: "hieraGif",
  group: "block",
  atom: true,
  addAttributes() {
    return {
      src: { default: null },
    };
  },
  parseHTML() {
    return [{ tag: 'img[data-hiera="gif"]' }];
  },
  renderHTML({ HTMLAttributes }) {
    return [
      "img",
      mergeAttributes(HTMLAttributes, {
        "data-hiera": "gif",
        loading: "lazy",
        decoding: "async",
      }),
    ];
  },
});

export const HieraCallout = Node.create({
  name: "hieraCallout",
  group: "block",
  content: "block+",
  defining: true,
  parseHTML() {
    return [{ tag: 'aside[data-hiera="callout"]' }];
  },
  renderHTML({ HTMLAttributes }) {
    return ["aside", mergeAttributes(HTMLAttributes, { "data-hiera": "callout", class: "callout" }), 0];
  },
});

export const HieraMermaid = Node.create({
  name: "hieraMermaid",
  group: "block",
  atom: true,
  addAttributes() {
    return {
      code: { default: "flowchart LR\n  A-->B" },
    };
  },
  parseHTML() {
    return [{ tag: 'div[data-hiera="mermaid"]' }];
  },
  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(HTMLAttributes, { "data-hiera": "mermaid", class: "mermaid-block" }),
      HTMLAttributes.code || "",
    ];
  },
});
